import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { RoleType } from '../../../types';

interface IProps {
  role: RoleType;
  customerId: string;
}

export const useGetPermissions = () =>
  useMutation('mutateInviteStatus', async ({ role, customerId }: IProps) => {
    const endpoint = `${BASE_URL}/api/v1/user/${customerId}/authorized/user/permissions`;

    const res = await httpService.post(endpoint, {
      authorizedUser: role,
    });
    return res;
  });
